import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import Permission from '../model/permissions.model'
import { FetchPermissionsProps, Permissions } from '../services/permissions.service'

import { StoreError } from '~/common/model'

export type PermissionsState = {
  loading: boolean
  error?: StoreError
  data?: Permission[]
}

export const initialState: PermissionsState = {
  loading: false,
  error: undefined,
  data: undefined,
}

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    fetchPermissions: (_state, _action: PayloadAction<FetchPermissionsProps>) => {
      return { ...initialState, loading: true }
    },
    fetchPermissionsSuccess(_state, action: PayloadAction<Permissions>) {
      const { payload } = action
      return { ...initialState, data: payload?.items, loading: false }
    },
    fetchPermissionsError(_state, action: PayloadAction<StoreError>) {
      const { payload } = action
      return { ...initialState, error: payload }
    },
  },
})

export const {
  fetchPermissions,
  fetchPermissionsSuccess,
  fetchPermissionsError,
} = permissionsSlice.actions

const permissionsReducer = permissionsSlice.reducer
export default permissionsReducer
